<template>
    <div class="parent-notification">
        <div v-html="$t('plane')" class="titleSchedule"/>
        <div>Нет данных</div>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'Plane'
}
</script>

<style lang="scss" scoped>

.titleSchedule{
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
}
.parent-notification {
    padding: 25px;
    font-family: Helvetica, sans-serif;
}
</style>
